export const value: number = 1;
export const min: number = 0;
export const max: number = Number.MAX_SAFE_INTEGER;
export const step: number = 1;
